import React from "react";
import { cn } from "./utils";

export default function SectionPanel({
  title = "",
  description = "",
  actions = null,
  children,
  className = "",
  contentClassName = "",
}) {
  return (
    <section className={cn("border border-slate-200 bg-white", className)}>
      {(title || actions || description) ? (
        <div className="border-b border-slate-200 px-4 py-3">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              {title ? <h2 className="text-sm font-semibold text-slate-900">{title}</h2> : null}
              {description ? <p className="mt-1 text-sm text-slate-600">{description}</p> : null}
            </div>
            {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
          </div>
        </div>
      ) : null}
      <div className={cn("p-4", contentClassName)}>{children}</div>
    </section>
  );
}
